import(/* webpackMode: "eager" */ "/app/src/app/[locale]/auth/signup/page.tsx");
